import "./Expertise.module.css";
import EnTêteDeNavigation from "@/reusable_sections/Header";
import B2BSolutionsCatalog from "./sections/B2BSolutionsCatalog";
import Footer from "@/reusable_sections/Footer";
export default function ExpertisePage() {
  return <div>
      <EnTêteDeNavigation />
      <B2BSolutionsCatalog />
      <Footer />
    </div>;
}